import { phAttrs } from "../lib/analytics/attrs.js";
import { ATTRIBUTE } from "../lib/analytics/surfaceVocabulary.js";
import { EYEBROW_CLASS, ROOT_NAV_TITLE_CLASS, ROOT_NAV_META_CLASS } from "../lib/ui.js";
import { rowChromeClass } from "./SidebarNavRuntime.jsx";

export function NavSectionLabel({ children }) {
  return (
    <div
      className={`${EYEBROW_CLASS} select-none pl-[6px] pr-[9px] pb-[6px] pt-[6px]`}
      aria-hidden="true"
    >
      {children}
    </div>
  );
}

// A list's New action atop the sidebar's list: a row with its plus where the
// mode rows have their icons (AppNav.jsx).
export function NavNewRow({ children, className = "", ...props }) {
  return (
    <button
      type="button"
      className={`flex h-[36px] w-full items-center gap-[11px] rounded-[8px] px-[9.5px] text-left text-[13px] font-medium text-[color:var(--ink)] transition-colors hover:bg-[color-mix(in_srgb,var(--side-raise)_55%,transparent)] ${className}`}
      {...props}
    >
      <span className="grid h-[17px] w-[17px] shrink-0 place-items-center rounded-[5px] bg-[color:var(--side-raise)]" aria-hidden="true">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="h-[11px] w-[11px]"><path d="M8 3.5v9M3.5 8h9" /></svg>
      </span>
      {children}
    </button>
  );
}

// The name over a list in the sidebar, as the dashboard's eyebrow.
export function NavListLabel({ children }) {
  return (
    <div className={`${EYEBROW_CLASS} select-none px-[9.5px] pb-[8px] pt-[16px]`} aria-hidden="true">
      {children}
    </div>
  );
}

export function NavDivider() {
  return <div className="ml-[6px] mr-[9px] my-[6px] h-px bg-[color:var(--line-soft)]" aria-hidden="true" />;
}

export function DimHeader({ label, count, loading, active, expanded, onClick, dimKey = null }) {
  return (
    <button
      type="button"
      onClick={onClick}
      {...phAttrs({ [ATTRIBUTE.DIM]: dimKey })}
      className={[
        "relative grid min-h-[24px] w-full [grid-template-columns:14px_minmax(0,1fr)_auto] items-center gap-x-2 border-0 bg-transparent py-0 pl-[6px] pr-[9px] text-left text-[color:var(--muted)] transition-colors appearance-none cursor-pointer hover:text-[color:var(--ink)]",
        // Idle-hover wash only - the active/expanded green fill for the folder
        // is painted by the enclosing StickyFolder, so DimHeader doesn't add
        // its own (that would double-tint the resting active state).
        rowChromeClass(false, true),
        active || expanded ? "text-[color:var(--ink)]" : "",
      ].join(" ")}
    >
      <span
        className="grid place-items-center [&_svg]:block [&_svg]:h-[13px] [&_svg]:w-[13px]"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={[
            "transition-transform",
            expanded ? "rotate-90" : "",
          ].join(" ")}
        >
          <path d="m6 3 5 5-5 5" />
        </svg>
      </span>
      <span className={ROOT_NAV_TITLE_CLASS}>{label}</span>
      {loading ? (
        <span
          className="h-[10px] w-[18px] justify-self-end rounded-[1px] bg-[color:var(--line-soft)] opacity-80"
          aria-label="Loading count"
        />
      ) : (
        <span className={ROOT_NAV_META_CLASS}>{count}</span>
      )}
    </button>
  );
}
